// util
import { defineStore } from 'pinia';
import request from '@/utils/request';
import { syncVConsole } from '@/utils/vconsole';

export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: {} // 用户信息
  }),
  actions: {
    /**
     * 设置用户信息，并同步 VConsole 白名单显示状态
     * @param {Object} userInfo
     */
    setUserInfo(userInfo) {
      this.userInfo = userInfo || {};
      syncVConsole(this.userInfo);
    },
    // 健康权益查询
    queryHealthQuanyi() {
      return request({
        method: 'get',
        url: SEVSRS + `/equity/v2/detail`,
        noLoading: true
      });
    },
    // 预警事件列表查询
    queryWarnEventList() {
      return request({
        method: 'get',
        url: SEVSRS + `/monitor/v1/abnormal/list?userCode=${this.userInfo.userCode}`,
        headers: { client: 'iosandroid' }
      });
    },
    // 提交意见反馈
    insertFeedback(data) {
      return request({
        method: 'post',
        url: SEVSRS + `/user/v1/feedback`,
        data
      });
    }
  },
  persist: {
    key: 'userStore',
    storage: localStorage,
  }
})



// WEBPACK FOOTER //
// ./src/stores/user.js